//import Message from "../../models/Message";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async fetchMessageScheduled(context, { accountId, messageScheduledId }) {
      let store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/messages-scheduled`,
          params: {
            accountId: accountId,
            id: messageScheduledId
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        store.dispatch("entities/messagesScheduled/insert", {
          data: response.data.data
        });
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async createMessageScheduled(context, message) {
      if (message.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/messages-scheduled`,
            data: {
              accountId: message.accountId,
              customerId: message.customerId,
              messageData: message.messageData,
              isSent: message.isSent,
              scheduledAt: message.scheduledAt,
              userId: message.userId
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/messagesScheduled/delete", {
            where: message.tempId
          });
          store.dispatch("entities/messagesScheduled/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateMessageScheduled(context, message) {
      if (message.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/messages-scheduled/${message.id}`,
            data: {
              accountId: message.accountId,
              id: message.id,
              customerId: message.customerId,
              messageData: message.messageData,
              isSent: message.isSent,
              scheduledAt: message.scheduledAt,
              userId: message.userId
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/update", {
            entity: "messagesScheduled",
            where: parseInt(response.data.id),
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async deleteMessageScheduled(context, message) {
      const store = this;
      store.dispatch("entities/messagesScheduled/delete", message.id);

      if (message.isDirty === true) {
        try {
          await axios({
            method: "patch",
            url: API_BASE_URL + `/messages-scheduled/${message.id}`,
            data: {
              accountId: message.accountId,
              id: message.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/messages-scheduled?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let messages = [];
    obj.forEach(function(message) {
      messages.push({
        id: message.id,
        isDirty: false,
        accountId: message.accountId,
        customerId: message.customerId,
        messageData: message.messageData,
        isSent: message.isSent,
        scheduledAt: Date.parse(message.scheduledAt),
        userId: message.userId,
        createdAt: Date.parse(message.createdAt),
        updatedAt: Date.parse(message.updatedAt)
      });
    });
    if (messages.length > 0) {
      store.dispatch("entities/messagesScheduled/insert", {
        data: messages
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
